import httpRequest from '@/server/http-api'
const shareWx = function(shareInfo) {
  let href = window.location.href.split("#")[0];
  // console.log(1111,href)
  var params = {
    url: href,
    // url: systemType == 'ios' ? encodeURIComponent(href) : href,
  };
   httpRequest.getShareWXSDK(params)
  .then(res => {
   
    var SDKParams = res.data
    wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: SDKParams.appid, // 必填，公众号的唯一标识
        timestamp: SDKParams.timestamp, // 必填，生成签名的时间戳
        nonceStr: SDKParams.noncestr, // 必填，生成签名的随机串
        signature: SDKParams.signature, // 必填，签名
        jsApiList: [
          "checkJsApi",
          "updateTimelineShareData",
          "updateAppMessageShareData",
          'onMenuShareTimeline',
          'onMenuShareAppMessage'
        ], // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-app']
    })
    wx.ready(function(){
      console.log('made it')
      wx.onMenuShareAppMessage({
        title:shareInfo.name, // 分享标题
        desc: shareInfo.summary, // 分享描述
        link: params.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl:'http://new-share.med-video.com/static/img/logo.4f07b2a.png', // 分享图标
        type: "link", // 分享类型,music、video或link，不填默认为link
        dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
        success: function() {
          // 设置成功
          // alert('onMenuShareAppMessage---成功');
        },
        error:function(){
          // alert('try more')
        }
      });
        wx.onMenuShareTimeline({
        title:shareInfo.name, // 分享标题
        link: params.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl:'http://new-share.med-video.com/static/img/logo.4f07b2a.png', // 分享图标
        success: function() {
          // 设置成功
          // alert('onMenuShareTimeline---成功');
        }
      });
    })
  })
  .catch(err => {
    console.log(111,err)
  });
}
export {
  shareWx
}


// WEBPACK FOOTER //
// ./src/utils/share.js